import * as React from 'react'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import Page from 'src/shared/Page/Page'
import PasswordTunnel from 'src/page/ValidationTunnel/PasswordTunnel'
import autobind from 'autobind-decorator'
import {RootState} from 'src/core/redux/reducer'
import {updatePassword} from 'src/core/redux/action/accountInfosAction'
import {connect} from 'react-redux'
import {WithToast} from 'src/type/lib/withToast'
import { config } from 'src/conf/config'
import {withToast} from 'src/shared/Toast'
import { css } from 'src/conf/style'
import { Theme, createStyles, WithStyles, Typography, withStyles } from '@material-ui/core'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'

const styles = (t: Theme) => createStyles({
  pageHead: {
    ...css.flexAlCenter,
    borderBottom: `1px solid ${t.palette.divider}`,
    minHeight: 72,
  },
  pageTitle: {
    width: css.pageWidth,
    margin: 'auto',
  }
})

interface IProps extends WithI18n,
  WithToast,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>{
  history?: any;
}

class ForgotPassword extends React.Component<IProps, any>{
  render(){
    const { t, classes } = this.props;
    return (
      <>
        <HelmetMeta title={t.App_title_page_ChangePassword}/>
        <div className={classes.pageHead}>
          <Typography variant="h5" className={classes.pageTitle}>{t.Change_password_title}</Typography>
        </div>
        
        <Page>
          <PasswordTunnel
            inTunnel={false}
            onSubmit={this.submitPassword}
            needReset={true}
          />
        </Page>
      </>
    )
  }

  @autobind
  private submitPassword(values){
    const { t, changePassword, toastSuccess, toastError } = this.props;
    changePassword(values)
      .then(() => {
        toastSuccess(t.Change_password_success);
        window.location.href = config.baseUrl + '/login'
      })
      .catch(err => {
        if(err.msg) toastError(err.msg);
      })
  }

}

const state2props = (state: RootState) => ({
  enterprise: state.accountInfo.enterpriseSelected,
  isFetching: state.accountInfo.isFetching,
  connectedUser: state.accountInfo.connectedUser,
});

const dispatch2props = dispatch => ({
  changePassword: (pwd) => dispatch(updatePassword(pwd))
});

export default compose(
  withI18n,
  withToast,
  withStyles(styles),
  connect(state2props, dispatch2props)
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/page/ForgotPassword/ForgotPassword.tsx